import React from 'react';
import PropTypes from 'prop-types';
// import Immutable from 'immutable';
import { Checkbox, IconButton } from '@ts/storybook';
import { Icon } from '@ts/storybook';
import { TableCell, TableHead, TableRow } from '@mui/material';
import { getPredefinedColumns } from './00-advancedSearchUtils';
import { withTranslation } from 'react-i18next';

class TableHeader extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      sortColumn: props.sortColumn,
      sortOrder: props.sortOrder,
      columns: props.columns,
      sortableColumns: props.sortableColumns,
    };
  }

  //#region Handlers
  _handleColHeadClick = colName => ev => {
    this.props.onColumnHeadClick(colName);
  };
  //#endregion

  //#region Functions
  getComponentColumnName = sortColumn => {
    // Get the component column name from the sortableColumns array
    const { sortableColumns } = this.props;

    const column = sortableColumns.find(c => c.sortColumn === sortColumn);
    return column ? column.field : null;
  };
  //#endregion

  //#region Renders
  //Never used?
  renderHeaderMultiSelection = () => {
    if (this.props.mode !== 'multiselection') return;
    return (
      <TableCell padding="checkbox">
        <Checkbox checked={this.props.checked} onChangeValue={this.props.onSelectAllClick} disabled={this.props.disabled} />
      </TableCell>
    );
  };

  renderHeaderColumns = () => {
    let rtl = this.props.lng == 'ar';
    let style;
    if (rtl) style = { textAlign: 'right' };
    const stickyCell = { position: 'sticky', right: 0, backgroundColor: '#fff' };
    let route = this.props.transferPropsRoute;

    let columns = getPredefinedColumns(route?.query?.column);
    this.predefinedColumns = this.props.columns;
    if (columns && columns.columns[0] != null) {
      this.predefinedColumns = [];
      columns.columns.map(column => {
        this.predefinedColumns = this.predefinedColumns.concat([]);
      });
    }

    return this.predefinedColumns.map((column, idx) => {
      if (column.fHidden) return null;

      return (
        <TableCell key={idx} style={column.name === 'moreActions' && !this.props.isModal ? { ...style, ...stickyCell } : style}>
          <span
            onClick={this._handleColHeadClick(column.name)}
            style={{ alignItems: 'center', display: 'flex', width: column.width }}
          >
            {this.renderIsSortable(column.name)}
            {this.props.t(column.fnLabel())}
            {this.renderSorting(column.name)}
          </span>
        </TableCell>
      );
    }, this);
  };

  renderIsSortable = colName => {
    const { sortableColumns } = this.props;

    if (!sortableColumns.find(column => column.field === colName)) return null;
    return <Icon icon="Reorder" />;
  };

  renderSorting = colName => {
    const componentColumnName = this.getComponentColumnName(this.state.sortColumn);
    if (componentColumnName !== colName) return null;
    let icon = 'Sort';
    return (
      <Icon
        icon={icon}
        style={{
          marginLeft: 10,
          transform: this.props.sortOrder == 'ASC' ? 'rotate(180deg)' : 'rotate(0deg)',
          height: 26,
        }}
      />
    );
  };
  renderCollapsableColumn = () => {
    return this.props.onClickCollapsable && this.props.rows.some(row => row.get('isCollapsable')) ? (
      <TableCell sx={{ width: '65px' }}>
        <IconButton aria-label="expand row" size="small" onClick={() => this.props.onClickCollapsable('all')}>
          <Icon icon={'KeyboardArrowDown'} />
        </IconButton>
      </TableCell>
    ) : (
      this.props.onClickCollapsable && <TableCell />
    );
  };
  //#endregion

  render() {
    return (
      <TableHead id="tableV3-header" sx={{ position: 'relative', zIndex: 1 }}>
        <TableRow>
          {this.renderHeaderMultiSelection()}
          {this.renderCollapsableColumn()}
          {this.renderHeaderColumns()}
        </TableRow>
      </TableHead>
    );
  }
}
TableHeader.propTypes = {
  // Base ------------------------------------------------
  columns: PropTypes.array.isRequired,
  rows: PropTypes.object,
  sortableColumns: PropTypes.array.isRequired,
  onColumnHeadClick: PropTypes.func.isRequired,
  sortColumn: PropTypes.string, // The DB column name
  //sortOrder: PropTypes.string.isRequired, // ASC or DESC
  // Multi-selection---------------------------------------
  onSelectAllClick: PropTypes.func,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  onClickCollapsable: PropTypes.func, //For close all collapsable
};

export default withTranslation()(TableHeader);
